import {
  Flex,
  FormElement,
  RadioButton,
  RADIOBUTTON_LABEL_FW_STANDARD
} from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const InputAction = () => {
  const intl = useIntl()

  const { Action } = useRecoilValue(step2State)

  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const handleChangeActionTrue = () => {
    setWorkflowDetailsState((prev) => ({ ...prev, Action: true }))
  }

  const handleChangeActionFalse = () => {
    setWorkflowDetailsState((prev) => ({ ...prev, Action: false }))
  }

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.WhenTriggerActivityFilterLabel'
      })}
      required
    >
      <Flex flexDirection='column' rowGap='8px' margin='24px 0 0 0'>
        <RadioButton
          id='triggerOnTrue'
          label={intl.formatMessage({
            id: 'Load.AutomationWorkflow.WhenTriggerActivityFilterIsTrue'
          })}
          labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
          value='true'
          checked={Action}
          onChange={handleChangeActionTrue}
        />
        <RadioButton
          id='triggerOnFalse'
          label={intl.formatMessage({
            id: 'Load.AutomationWorkflow.WhenTriggerActivityFilterIsFalse'
          })}
          labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
          value='false'
          checked={!Action}
          onChange={handleChangeActionFalse}
        />
      </Flex>
    </FormElement>
  )
}

export default InputAction
